import { MutationOptions } from '@tanstack/react-query';
import { createZipVehiclePicturesQueryFunction } from '@/modules/FileDetail/queries/documentation/createZip/createZipVehiclePictures/createZipVehiclePicturesQueryFunction';
import {
  CreateZipVehiclePicturesResponseType,
  CreateZipVehiclePicturesZipType,
} from '@/modules/FileDetail/queries/documentation/createZip/createZipVehiclePictures/createZipVehiclePicturesQuery.type';

export const createZipVehiclePicturesQueryOptions = (): MutationOptions<
  CreateZipVehiclePicturesResponseType,
  Error,
  CreateZipVehiclePicturesZipType
> => ({
  mutationKey: ['createZipVehiclePicturesQueryOptions'],
  mutationFn: (params: CreateZipVehiclePicturesZipType) =>
    createZipVehiclePicturesQueryFunction({
      id: params.id,
      images_quality: params?.images_quality,
    }),
});
